import React from 'react'
import {Table} from 'reactstrap'
import moment from 'moment'
import PropTypes from 'prop-types'
import _ from 'lodash'

const HoursWorked = ({hours_worked}) => {

    if(!hours_worked || !hours_worked.length) return <p>No Data</p>

    const grandTotal = _.sumBy(hours_worked, 'total_minutes_worked')
    const groups = hours_worked.reduce((carry, {year, month}) => {
        carry[`${year}-${month}`] = true
        return carry
    }, {})
    const offices = hours_worked.reduce((carry, {description, month, year, total_minutes_worked}) => {
        let currentTotal = (carry[description] && carry[description].hasOwnProperty('total') ? carry[description].total : 0)
        carry[description] = {
            ...carry[description],
            total: parseFloat(currentTotal) + parseFloat(total_minutes_worked),
            [`${year}-${month}`]: total_minutes_worked
        }
        return carry
    }, {})

    console.log('things', groups, offices)

    return (
        <Table>
            <thead>
                <tr>
                    <th>Date</th>
                    {offices && Object.keys(offices).map(office => <th>{office}</th>)}
                </tr>
            </thead>
            <tbody>

                {Object.keys(groups).map((date, index) => {
                    return (
                        <tr key={index}>
                            <td>{moment(`${date}-01`).format('MMM YY')}</td>
                            {Object.keys(offices).map(name => {
                                if(offices[name][date]){
                                    return <td>{(offices[name][date] / 60).toFixed(2)}</td>
                                }
                                return <td>0</td>
                            })}
                        </tr>
                    )
                })}


            </tbody>
            <tfoot>
                <tr>
                    <td className="font-weight-bold">Total</td>
                    {offices && Object.keys(offices).map(name => <td className="font-weight-bold">{(offices[name].total / 60).toFixed(2)}</td>)}
                </tr>
            </tfoot>
        </Table>
    )

}

HoursWorked.propTypes = {
    hours_worked: PropTypes.array.isRequired
}

export default HoursWorked